import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import Table from "../../components/Table";
import RefreshParc from "./RefreshParc";
import NumberCard from "../../components/Card/NumberCard";
import Globalview from "../../components/Globalview";
import RowAuvik from "./RowAuvik";
import { Auvikcolumns } from "../../components/headerContent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Loader from "../../components/Loader";

export default function AllDevices({ tenantId }) {
    const { apiUrl, user } = useContext(AuthContext);
    const [devicesByType, setDevicesByType] = useState([]);
    const [resetValue, setResetValue] = useState(false);
    const [valueType, setValueType] = useState("all");
    const [refreshStatus, setRefreshStatus] = useState(false);
    const typeCounts = { name: "Type" };
    const { t } = useTranslation();

    const getDevices = async () => {
        try {
            const res = await axios.get(`${apiUrl}auvik/devices/${tenantId}`, {
                withCredentials: true,
            });
            return res.data;
        } catch (error) {
            return [];
        }
    };

    const devices = useQuery({
        queryKey: ["devices", tenantId],
        queryFn: getDevices,
    });

    const deviceRows = Array.isArray(devices.data) ? devices.data : [];

    if ((devices.isFetched && devices.data && devices.data.errors) || (devices.isFetched && !devices.data)) {
        return (
            <div className="ecp-container">
                <div className="ecp-container-content-error">
                    <div className="error-container">
                        <img src="../assets/ecp_error.svg" alt="icône d'erreur" />
                        <div className="error-container-text">
                            <h1 className="page-title">
                                {t("Aucune donnée Auvik disponible")}
                            </h1>
                            <p className="page-link_home">
                                <Link to="/"> {t("Revenir à  l'accueil")}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const devicesFilterByType = () => {
        const filterByType = deviceRows.filter((item) => {
            return (
                item.deviceType === valueType ||
                (valueType === "switch" && ["switch", "stack", "l3Switch", "controller"].includes(item.deviceType))
            );
        });
        setDevicesByType(filterByType);
    };

    useEffect(() => {
        if (valueType !== "all") {
            devicesFilterByType();
            return;
        }

        setDevicesByType([]);
    }, [valueType, devices.data]);

    const handleRefresh = () => {
        setRefreshStatus(true);
    };

    return (
        <>
            {!devices.isFetching ? (
                <section className="auvik-alldevices">
                    <div className="page-title page-link-auvik-tenant">
                        <div className="page-title-auvik">
                            <Link to={"/auvik"} className="button button-new"><FontAwesomeIcon icon={faChevronLeft} /> {t("Retour")}</Link>
                            <h2 className="auvik-alldevices-title">Interfaces</h2>
                        </div>
                        {user.roles.includes("ROLE_SUPERADMIN") && (
                            <button className="button button-new" onClick={handleRefresh}>{t("Rafraîchir le parc")}</button>
                        )}
                        <Link to={`/auvik/${tenantId}/alerts`} className="button button-new">{t("Alert history")} <FontAwesomeIcon icon={faChevronRight} /></Link>
                    </div>
                    <section className="page-section">
                        <NumberCard number={deviceRows.length} title="Nombre d'équipements" />
                        {deviceRows.length > 0 && (
                            <Globalview
                                data={deviceRows}
                                setValueType={setValueType}
                                countObject={typeCounts}
                                objectKey="deviceType"
                                click
                                resetValue={resetValue}
                                setResetValue={setResetValue}
                            />
                        )}
                        {valueType !== "all" && (
                            <button
                                className="button button-new page-reset"
                                onClick={() => {
                                    setValueType("all");
                                    setResetValue(true);
                                    setDevicesByType([]);
                                }}
                            >
                                {t("Réinitialiser")}
                            </button>
                        )}
                    </section>
                    <div className="table-interfaces-leftbtn">
                        <h2 className="card-title">{t("Légende des statuts d'interface")} :</h2>
                        <div className="legend-status">
                            <div><span className="online-legend-status"></span><p>Online</p></div>
                            <div><span className="offline-legend-status"></span><p>Offline</p></div>
                            <div><span className="dormant-legend-status"></span><p>{t("Autres")}</p></div>
                            <div><FontAwesomeIcon icon={faCircleExclamation} color="rgb(255, 187, 0)" /><p>{t("Afficher les alertes d'un équipement")}</p></div>
                        </div>
                    </div>
                    <section className="cato-content">
                        <div className="cato-content-table">
                            <Table
                                tableData={devicesByType.length > 0 ? devicesByType : deviceRows}
                                tableColumns={Auvikcolumns}
                                rowComponent={RowAuvik}
                            />
                        </div>
                    </section>
                </section>
            ) : (
                <Loader />
            )}
            <RefreshParc setRefreshStatus={setRefreshStatus} tenantId={tenantId} refreshStatus={refreshStatus} />
        </>
    );
}
